import { TextModelList } from './components/TextModelList';
import styles from './OtherModelsSelector.module.scss';
import { useActiveModel } from 'src/hooks/userSettingsHooks/useActiveModel';
import { SettingLLMModels } from 'src/types/settings';
import cn from 'classnames';
import { ArrowLeft } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useCompareMode } from 'src/hooks';

interface OtherModelsSelectorProps {
  onCloseExternalModels: () => void;
  onCloseSelector: () => void;
  isOpen: boolean;
  modelsList?: SettingLLMModels;
  showRegenerate?: boolean;
  onRegenerateClick?: (value: string) => void;
  isComparingMode?: boolean;
  shouldOpenExternalModelsByClick?: boolean;
  onComparingModelChange?: (value: string) => void;
  compareModel?: string;
}

export const OtherModelsSelector = ({
  isOpen,
  onCloseExternalModels,
  onCloseSelector,
  modelsList,
  showRegenerate,
  onRegenerateClick,
  isComparingMode,
  onComparingModelChange,
  shouldOpenExternalModelsByClick,
  compareModel,
}: OtherModelsSelectorProps) => {
  const { changeCurrentModel } = useActiveModel();
  const { changeFirstCompareModel } = useCompareMode();

  const handleChangeValue = (item: string) => {
    if (showRegenerate && !!onRegenerateClick) {
      onRegenerateClick(item);
    } else if (!isComparingMode) {
      changeCurrentModel(item);
      changeFirstCompareModel(item);
    } else if (isComparingMode) {
      onComparingModelChange?.(item);
    }

    onCloseSelector();
  };

  if (!isOpen || !modelsList || modelsList?.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(styles.tooltip, {
        [styles.regenerateTooltip]: showRegenerate,
        [styles.displayedSeparately]: !shouldOpenExternalModelsByClick,
      })}
    >
      {shouldOpenExternalModelsByClick && (
        <Button
          color="transparent"
          onClick={onCloseExternalModels}
          className={styles.header}
        >
          <ArrowLeft size={SVG_SIZE_M} />

          <span className={styles.backText}>Additional 30+ AI models</span>
        </Button>
      )}

      <TextModelList
        compareModel={compareModel}
        isComparingMode={isComparingMode}
        onClick={handleChangeValue}
        modelsList={modelsList}
        showRegenerate={showRegenerate}
      />
    </div>
  );
};
